import React from 'react';
import './LobbyFactionTiles.css';
import LobbyFactionArt from './LobbyFactionArt';
import LobbyBanVoteChips from './LobbyBanVoteChips';
import FactionBanMark from '../../FactionBanMark/FactionBanMark';

/**
 * Плитка фракции рейтингового лобби: полный арт со скином игрока, имя цветом
 * фракции, голоса за бан чипами с никами, метка бана и подпись состояния.
 * Что делает нажатие, решает вызывающий (голос, выбор или карточка фракции)
 * — плитка только показывает.
 *
 * @param {Object} props
 * @param {Object} props.tile - описание плитки (см. LobbyFactionTiles)
 */
const LobbyFactionTile = ({tile}) => {
  const {display} = tile;
  const className = [
    'lobby-faction-tile',
    tile.isInteractive ? 'lobby-faction-tile_interactive' : '',
    tile.isSelected ? 'lobby-faction-tile_selected' : '',
    tile.banMark === 'final' ? 'lobby-faction-tile_banned' : '',
    tile.banMark === 'vote' ? 'lobby-faction-tile_voted' : '',
    display.framePath ? 'lobby-faction-tile_framed' : '',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={className}
      data-faction-id={tile.factionId}
      title={tile.title || display.name}
      onClick={tile.onClick}
      onDoubleClick={tile.onDoubleClick}
    >
      <LobbyFactionArt display={display} className="lobby-faction-tile_art" withFrame flashAt={tile.flashAt}/>
      {tile.banMark && (
        <FactionBanMark
          className="lobby-faction-tile_ban-mark"
          isFinal={tile.banMark === 'final'}
          title={tile.banTitle}
        />
      )}
      <div className="lobby-faction-tile_top">
        {tile.label && (
          <span className={`lobby-faction-tile_label lobby-faction-tile_label_${tile.labelKind || 'neutral'}`}>
            {tile.label}
          </span>
        )}
        <LobbyBanVoteChips voters={tile.voters}/>
      </div>
      <div className="lobby-faction-tile_name" style={{color: display.textColor}}>{display.name}</div>
      {tile.onInfo && (
        <button
          type="button"
          className="lobby-faction-tile_info"
          title="Подробно о фракции"
          onClick={(event) => {
            event.stopPropagation();
            tile.onInfo();
          }}
          // Двойное нажатие по кнопке — не двойное нажатие по плитке
          onDoubleClick={(event) => event.stopPropagation()}
        >
          i
        </button>
      )}
    </div>
  );
};

/**
 * Четверка фракций игрока рейтингового лобби плитками. Раскладка — по форме
 * места: 2×2, четыре в ряд (широкое место) или столбиком (узкое высокое), так
 * чтобы плитки были как можно крупнее (см. LobbyFactionTiles.css).
 *
 * Описание плитки: {factionId, display (getLobbyFactionDisplay), voters,
 * banMark ('vote' — свой голос в фазе, 'final' — итог банов), banTitle,
 * isSelected (своя выбранная), label, labelKind, title, isInteractive, flashAt,
 * onClick, onDoubleClick, onInfo}.
 *
 * @param {Object} props
 * @param {Array<Object>} props.tiles
 * @param {string} [props.className]
 */
const LobbyFactionTiles = ({tiles, className = ''}) => (
  // Хоть у одной плитки рамка лиги — зазоры набора растут под ее выступ
  <div className={`lobby-faction-tiles ${tiles.some((tile) => tile.display.framePath) ? 'lobby-faction-tiles_framed' : ''} ${className}`}>
    <div className="lobby-faction-tiles_grid" data-tiles-count={tiles.length}>
      {tiles.map((tile) => <LobbyFactionTile key={tile.factionId} tile={tile}/>)}
    </div>
  </div>
);

export default LobbyFactionTiles;
